<template>
    <div>
        <form>
            <div class="form-group">
                <label>{{ __('forms.SkillsFamilies.parent') }}</label>
                <select class="form-control" id="newFamily" @change="changeFamily($event)">
                    <option value="">---</option>
                    <option v-for="family in skill_families" :value="family.id">
                        {{ family.name }}
                    </option>
                </select>
            </div>
            <div class="form-group">
                <label>{{ __('forms.Skills.name') }}</label>
                <select class="form-control" id="newSkill" v-model="newSkill">
                    <option value="">---</option>
                    <option v-for="skill in skills" :value="skill.id">
                        {{ skill.name }}
                    </option>
                </select>
            </div>
            <div class="form-group">
                <label>{{ __('forms.SkillsLevels.level') }}</label>
                <select class="form-control" id="newLevel" v-model="newLevel">
                    <option value="">---</option>
                    <option v-for="level in levels" :value="level.id">
                        {{ level.title }}
                    </option>
                </select>
            </div>
            <div class="d-flex justify-content-end">
                <a class="btn btn--green mt-3" @click="addPersonSkillsLevelRow()" href="#"> {{ __('misc.add') }}</a>
            </div>
        </form>

        <div>
            <h6 class="text-primary mb-3">Elenco Skill</h6>

            <div class="table-responsive">
                <table class="table table-personal-skills">
                    <thead>
                        <tr>
                            <th>{{ __('forms.Skills.name') }}</th>
                            <th>{{ __('forms.SkillsLevels.level') }}</th>
                            <th>{{ __('misc.actions') }}</th>
                        </tr>
                    </thead>
                    <tbody>

                        <tr v-for="(row, index) in insertSkills">

                            <td>{{ row.skill_name }}</td>


                            <td>{{ row.skill_level_name }}
                            </td>

                            <td>
                                <a href="#" @click="deleteRow(index)" class="btn btn--mini btn--only-icon btn--transparent circle-button circle-button-remove mx-1"><i class="fas fa-trash"></i></a>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <div class="d-flex justify-content-end">
                    <button class="btn btn--green mt-3" @click="storeSkills()">{{ __('misc.save') }}</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {

    components: {

    },
    data() {
        return {
            skills: [],

            newSkill: null,
            newLevel: null,
            familyId: null,
            insertSkills: []
        }
    },
    mounted() {

        this.getSkills(this.familyId);
    },
    methods: {

        changeFamily(event) {
            this.familyId = event.target.value;
            this.getSkills(this.familyId);
        },
        deleteRow(index) {
            Vue.delete(this.insertSkills, index);
        },
        addPersonSkillsLevelRow() {

            if (this.newSkill == "" || this.newLevel == "") {
                return false;
            }

            let row = {
                skill_id: this.newSkill,
                level_id: this.newLevel,
                skill_name: document.getElementById("newSkill").options[document.getElementById("newSkill").options.selectedIndex].text,
                skill_level_name: document.getElementById("newLevel").options[document.getElementById("newLevel").options.selectedIndex].text,
            }

            this.insertSkills.push(row);
            this.newSkill = this.newLevel = null;
        },
        getSkills() {
            axios.get("/skills-for-bulk-create", {
                params: {
                    "skill_family": this.familyId
                }
            }).then((response) => {
                this.newSkill = this.newLevel = null;
                this.skills = response.data;
            });
        },
        storeSkills() {

            axios.post("/people-skills-bulk-store/" + this.person + "/person", { skills_request: this.insertSkills }).then((response) => {
                app.__vue__.$refs.profile_person_skill.populateSkillTable();
                this.insertSkills = [];
                app.__vue__.$refs.vue_sidebar.active = false;
                Vue.swal.fire({
                    title: response.data + ' skills aggiunte con successo',
                    text: "",
                });
            });
        }
    },



    props: {

        skill_families: {
            type: Array,
            required: true,
        },
        levels: {
            type: Array,
            required: true,
        },
        person: {
            type: Number,
            required: true
        },
    }
}
</script>
